import isZeroOrPositiveInteger from "./isZeroOrPositiveInteger";

const isPositiveInteger = candidate =>
  isZeroOrPositiveInteger(candidate) && candidate > 0;

export default isPositiveInteger;
